// extracted by mini-css-extract-plugin
export default {"box":"Success-box-c0390e6974e109f3520f896e035cfb2b","title":"Success-title-81680bd5265688eb379d0c1f2ff84e62"};